import { ResourceBuilder } from '@salsita-ai/platform-project-sdk/domain';
import { adminDomainBuilder, adminInvariantBuilder } from './__generated/admin-implementation.js';
import { generatedConfiguratorBuilder } from './__generated/configurator-builder.js';
import { domainBuilder, invariantBuilder } from './__generated/implementation.js';
import { apronExpressions } from './implementations/apron.js';
import { baseDoubleLegExpressions } from './implementations/base-double-leg.js';
import { baseFourLegCombinedExpressions } from './implementations/base-four-leg-combined.js';
import { baseFourLegSeparateExpressions } from './implementations/base-four-leg-separate.js';
import { baseSingleLegExpressions } from './implementations/base-single-leg.js';
import { baseExpressions, baseInvariants } from './implementations/base.js';
import { benchExpressions } from './implementations/bench.js';
import { tableExpressions, tableInvariants } from './implementations/table.js';
import { topWithDiameterExpressions } from './implementations/top-with-diameter.js';
import { topWithWidthExpressions } from './implementations/top-with-side.js';
import { topWithWidthAndLengthExpressions } from './implementations/top-with-width-and-length.js';
import { topExpressions, topInvariants } from './implementations/top.js';
const adminViolationExpressions = adminInvariantBuilder.buildViolationExpressions();
export const adminDomainFactory = adminDomainBuilder.withExpressions(adminViolationExpressions).build();
const violationExpressions = invariantBuilder.withInvariants(tableInvariants).withInvariants(topInvariants).withInvariants(baseInvariants).buildViolationExpressions();
const createDomain = domainBuilder.withExpressions(violationExpressions).withExpressions(tableExpressions).withExpressions(topExpressions).withExpressions(topWithWidthExpressions).withExpressions(topWithWidthAndLengthExpressions).withExpressions(topWithDiameterExpressions).withExpressions(baseExpressions).withExpressions(baseSingleLegExpressions).withExpressions(baseDoubleLegExpressions).withExpressions(baseFourLegCombinedExpressions).withExpressions(baseFourLegSeparateExpressions).withExpressions(apronExpressions).withExpressions(benchExpressions).build();
const resources = new ResourceBuilder().addLink({
    type: 'ConfigurationLink',
    name: 'ownerLink'
}).addLink({
    type: 'ConfigurationLink',
    name: 'readLink'
}).addLink({
    type: 'ConfigurationLink',
    name: 'readRevisionLink'
}).addClientGeneratedImage({
    type: 'Image',
    name: 'clientGeneratedImage',
    s3Key: `clientGeneratedImage`,
    clientGenerated: true
}).build();
export const configuratorBuilder = generatedConfiguratorBuilder.withDomainFactory(createDomain).withAdminDomainFactory(adminDomainFactory).withResources(resources);
export * as ApplicationTypes from './__generated/application-types.js';
export * as EnhancedDomain from './__generated/enhanced-model.js';
export * as Model from './__generated/model/index.js';
export * as AdminEnhancedDomain from './__generated/admin-enhanced-model.js';
export * as AdminModel from './__generated/admin-model/index.js';
export { createPresets } from './__generated/presets.js';
export { createAdminPresets } from './__generated/admin-presets.js';
export { attachComponent, createRecipe } from './__generated/implementation.js';
export { attachAdminComponent, createAdminRecipe } from './__generated/admin-implementation.js';
export { SEATING_MAP } from './data/table-data.js';
export { DISTRESS_SCRATCH_REPEAT_RATIO_INCHES, FINISH_MAP, SHEEN_MAP, WOOD_SPECIES_MAP } from './data/texture-data.js';
export { THICKNESS_OPTIONS, TOP_DISTRESS_LEVEL_OPTIONS, TOP_EDGE_STYLE_OPTIONS } from './data/top-data.js';
export { PRICING_CONFIG } from './data/pricing-config.js';
export { PRICING_GROUPS, BASE_SUBCATEGORIES, getBaseSubcategoryData, getUncategorizedBases, filterHiddenKeys, formatLabel } from './data/pricing-categories.js';
export { default as mapPublishedChunkedData } from './handlers/map-published-chunked-data.js';

//# sourceMappingURL=index.js.map